<span class="quality-feedback-card-title" translate>quality.feedback.card.title</span>
<ng-container *ngIf="howManyLoaded === 6 else loading">
	<div class="quality-feedback-card-issues">
		<a mat-button class="quality-feedback-card-issues-label" [routerLink]="['/quality-issues/list']"
			[state]="viewDetailsState(true)"><span class="quality-feedback-card-footer-label"
				translate>quality.feedback.card.open.issues</span></a>
		<a mat-button class="quality-feedback-card-issues-label" [routerLink]="['/quality-issues/list']"
			[state]="viewDetailsState(false)"><span class="quality-feedback-card-footer-label"
				translate>quality.feedback.card.closed.issues</span></a>
	</div>
		<div class="quality-feedback-card-issues">
		<a class="quality-feedback-card-issues-total" [routerLink]="['/quality-issues/list']" [state]="viewDetailsState(true)">{{ openIssues }}</a>
		<a class="quality-feedback-card-issues-total" [routerLink]="['/quality-issues/list']" [state]="viewDetailsState(false)">{{ closedIssues }}</a>
	</div>
	<span class="quality-feedback-card-subtitle" translate>quality.feedback.card.subtitle</span>
	<div class="quality-feedback-card-widget">
		<copo-quality-feedback-bars [data]="widgetData"></copo-quality-feedback-bars>
	</div>
	<a mat-button class="quality-feedback-card-footer" [routerLink]="['/quality-issues/list']" [state]="{ filter: [] }">
		<span class="quality-feedback-card-footer-label" translate>quality.feedback.card.details</span>
		<mat-icon iconPositionEnd svgIcon="md:chevron_right" color="accent"></mat-icon>
	</a>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
